export const initial = {};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'RANKING_INVITE_SET':
      return action.payload;
    case 'RANKING_INVITE_CLEAR':
      return initial;
    case 'RANKING_INVITE_NOT_FOUND':
      return { notFound: true };
    default:
      return state;
  }
};
